/**
 * URL工具函数
 */

interface MarketingParams {
  source?: string;
  affiliateId?: string;
}

/**
 * 从URL中提取营销参数
 * @param url 完整的URL字符串，如果不提供则使用当前页面URL
 * @returns 包含source和affiliateId的对象
 */
export const extractMarketingParams = (url?: string): MarketingParams => {
  const targetUrl = url || window.location.href;
  const urlObj = new URL(targetUrl);
  const searchParams = urlObj.searchParams;

  return {
    source: searchParams.get('source') || '',
    affiliateId: searchParams.get('affiliateId') || ''
  };
};

/**
 * 判断应用内是否有上一页（react-router 会在 history.state.idx 记录当前位置）
 */
export const canGoBack = (): boolean => window.history.state?.idx > 0;
